import React, { useState, useEffect } from "react"
import axios from "axios"
import Spinners from "components/Common/Spinner"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, Container } from "reactstrap"

const Home = () => {
  const [NewURL, setNewURL] = useState(null)
    const [error, setError] = useState(null);
    const token = JSON.parse(localStorage.getItem("Token"));

  const liveUrl = "https://marcopolo.prisms.in"
  const acadId = localStorage.getItem("acad_id");
  const navigate = useNavigate()


  useEffect(() => {
    if (!token || !acadId) {
      setError("Authentication failed");
      return;
    }

    const fetchUrl = async () => {
      try {
        const { data } = await axios.post(`${liveUrl}/api/parent-campaign/getLink`, 
          { acad_id: acadId },
          { headers: { Authorization: token } }
        );
        setNewURL(data.url);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to fetch the URL");
      }
    };

    fetchUrl();
  }, [token, acadId]);

  useEffect(() => {
    if (NewURL) {
      window.history.pushState(null, "", "/dashboard")
      const timer = setTimeout(() => {
        window.location.href = NewURL
      }, 200)

      const handlePopState = () => {
        navigate("/dashboard")
      }

      window.addEventListener("popstate", handlePopState)

      return () => {
        clearTimeout(timer)
        window.removeEventListener("popstate", handlePopState)
      }
    }
  }, [NewURL, navigate])

    if (error) {
      return (
        <div className="page-content text-center text-danger">
          <h4>{error}</h4>
        </div>
      );
    }
  
    if (!NewURL) {
      return (
        <div className="page-content">
          <Spinners />
        </div>
      );
    }
  

  return (
    <div className="page-content">
      <Container>
        <Card>
          <CardBody>
            <h4 className="fs-5 text-center text-dark">Redirecting...</h4>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default Home
